var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 5.83341H7.58335C6.98504 5.83341 6.50002 6.31844 6.50002 6.91675C6.50002 7.51506 6.98504 8.00008 7.58335 8.00008H8.41669C9.015 8.00008 9.50002 8.48511 9.50002 9.08341C9.50002 9.68172 9.015 10.1667 8.41669 10.1667H6.50002M8.00002 5.16675V5.50008M8.00002 10.5001V10.8334M12.8334 8.00008C12.8334 10.6695 10.6694 12.8334 8.00002 12.8334C5.33064 12.8334 3.16669 10.6695 3.16669 8.00008C3.16669 5.3307 5.33064 3.16675 8.00002 3.16675C10.6694 3.16675 12.8334 5.3307 12.8334 8.00008Z",
    stroke: "#D50B3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.06f18de386d00a513ea8dcb44adbcdd1.svg";
export { ForwardRef as ReactComponent };